import { Signal } from "@angular/core";
import { IDataProvider } from "../interfaces/IDataProvider";
import { GenericRepository } from "../repositories/generic-repository";

export class DataProvider<T> implements IDataProvider<T> {
  public data: Signal<T[]>;

  public constructor(
    private repository: GenericRepository<T>
  ) {
    this.repository.fetch();
    this.data = this.repository.getData;
  }
}
